import request from '@/utils/request'


// 查询充值菜单列表
export function listRechargeMenu(query) {
  return request({
    url: '/golf/golf-recharge-menu/list',
    method: 'get',
    params: query
  })
}

// 查询充值菜单分页
export function pageRechargeMenu(query) {
  return request({
    url: '/golf/golf-recharge-menu/page',
    method: 'get',
    params: query
  })
}

// 查询充值菜单详细
export function getRechargeMenu(data) {
  return request({
    url: '/golf/golf-recharge-menu/detail',
    method: 'get',
    params: data
  })
}

// 新增充值菜单
export function addRechargeMenu(data) {
  return request({
    url: '/golf/golf-recharge-menu/add',
    method: 'post',
    data: data
  })
}

// 修改充值菜单
export function updateRechargeMenu(data) {
  return request({
    url: '/golf/golf-recharge-menu/edit',
    method: 'post',
    data: data
  })
}

// 删除充值菜单
export function delRechargeMenu(data) {
  return request({
    url: '/golf/golf-recharge-menu/delete',
    method: 'post',
    data: data
  })
}
